import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Grid } from '@material-ui/core/';
import { selectUser } from '~/store/legacy/selector/userSelectors';
import { openDialog } from '~/store/legacy/actions/dialogActions';
import InternationalPhoneDisplay from '../InternationalPhoneDisplay';
import PhoneVerification from '../PhoneVerification';
import useStyles from './PhoneNumber.style';

/**
 * Display phone number and handle verification if necessary.
 */
const PhoneNumber = () => {
  const [dispatch, classes] = [useDispatch(), useStyles()];
  const user = useSelector(selectUser);
  useEffect(() => {
    const { phone_number, verified } = user;
    if (!phone_number || !verified) {
      dispatch(
        openDialog({
          title: 'Please verify your phone number.',
          message: <PhoneVerification />,
        })
      );
    }
  }, [user]);

  return (
    <Grid container className={classes.container}>
      <Typography variant='body1'>
        <FormattedMessage id='page.checkout.phone_number.phone_number_on_file' />
        &nbsp;
        {user.phone_number && <InternationalPhoneDisplay phoneNumber={user.phone_number} />}
      </Typography>
    </Grid>
  );
};

export default PhoneNumber;
